import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

// Allowed characters in cardholder name (everything else is stripped):
//   \p{L}    — letters (all scripts)
//   \p{M}    — combining marks (e.g. accents, diacritics)
//   \s       — space
//   '        — apostrophe (e.g. O'Brien)
//   \u2019   — right single quotation mark (e.g. O\u2019Brien)
//   -        — hyphen (e.g. Mary-Jane)
//   .        — period (e.g. Jr.)
//   ,        — comma
const ALLOWED_PATTERN = /[^\p{L}\p{M}\s'\u2019\-.,]/gu;

@Directive({
  selector: '[appNameSanitizer]'
})
export class NameSanitizerDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2,
    private control: NgControl
  ) {}

  @HostListener('input')
  onInput(): void {
    const inputEl = this.el.nativeElement;
    const currentValue = inputEl.value;
    const cursorPos = inputEl.selectionStart || 0;

    const sanitized = currentValue.replace(ALLOWED_PATTERN, '');

    if (sanitized !== currentValue) {
      const removedBeforeCursor = currentValue.slice(0, cursorPos).length - currentValue.slice(0, cursorPos).replace(ALLOWED_PATTERN, '').length;

      if (this.control?.control) {
        this.control.control.setValue(sanitized, { emitEvent: true });
      }
      this.renderer.setProperty(inputEl, 'value', sanitized);
      const newCursorPos = cursorPos - removedBeforeCursor;
      inputEl.setSelectionRange(newCursorPos, newCursorPos);
    }
  }

  @HostListener('paste')
  onPaste(): void {
    setTimeout(() => this.onInput());
  }
}
